// extracted by mini-css-extract-plugin
export var container = "link-rounded-module--container--ruEDH";
export var icon = "link-rounded-module--icon--DpG2q";
export var text = "link-rounded-module--text--tS5HF";
export var wrapper = "link-rounded-module--wrapper--bQO1s";